// AdminDashboard.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./admindashboard.css";
import CategoryAnalysis from "../feedbackreports/CategoryAnalysis";
import axios from "axios";
import logo from "./unexttitlebar.png";
import logoutIcon from "./logout.png";
import Select from "react-select";

const AdminDashboard = () => {

  // Existing states
  const [userId, setUserId] = useState(null);
  const [email, setEmail] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isDownloadingCSV, setIsDownloadingCSV] = useState(false);
  const [isLoadingAnalysis, setIsLoadingAnalysis] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
const [showDownloadDevModal, setShowDownloadDevModal] = useState(false);

  const navigate = useNavigate();

  // NEW modal states
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState("");
  const [selectedParticipant, setSelectedParticipant] = useState("");

  // Load admin email
  useEffect(() => {
    const storedEmail = localStorage.getItem("email");
    if (storedEmail) {
      setAdminEmail(storedEmail);
    } else {
      navigate("/admin/login");
    }
  }, [navigate]);

  // Load programs when modal opens
  useEffect(() => {
    if (!showDownloadModal) return;

    axios
  .get("/api/adminprograms")
  .then((res) => setPrograms(res.data))
  .catch((err) => console.error("Failed to load programs", err));
  }, [showDownloadModal]);

  // Load participants when program changes
  const handleProgramSelect = async (programId) => {
    setSelectedProgram(programId);
    setParticipants([]);
    setSelectedParticipant("");

    try {
      const res = await axios.get(`/api/admin/program/${programId}/participants`);
      setParticipants(res.data);
    } catch (err) {
      console.error("Failed to load participants", err);
    }
  };

  // Download participant-level report
  const handleDownloadParticipantReport = async () => {
    try {
      const res = await axios.get(
        `/api/admin/download-report?programId=${selectedProgram}&participantId=${selectedParticipant}`,
        { responseType: "blob" }
      );


      // Extract filename from header
    const disposition = res.headers["content-disposition"];
    let filename = "participant_360_report.xlsx";

    if (disposition && disposition.includes("filename=")) {
      filename = disposition
        .split("filename=")[1]
        .replace(/"/g, "")
        .trim();
    }

      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();

      setShowDownloadModal(false);
    } catch (err) {
      console.error("Failed to download report", err);
      setErrorMessage("Failed to download participant report.");
    }
  };

  // Logout
  const handleLogout = () => {
    localStorage.removeItem("email");
    navigate("/admin/login");
  };

  // View Results
  const handleViewResults = async () => {
    setIsLoadingAnalysis(true);
    setErrorMessage("");

    try {
      const res = await axios.get(
        `/api/admin/users/resolve-id?email=${encodeURIComponent(email)}`
      );

      if (!res.data?.userId) {
        setErrorMessage("No user found with this email");
        return;
      }
      setUserId(res.data.userId);
    } catch (err) {
      setErrorMessage("Failed to fetch user results.");
    } finally {
      setIsLoadingAnalysis(false);
    }
  };

  // Date-based full report
  const handleDownloadByDate = async () => {
    if (!fromDate || !toDate) {
      setErrorMessage("Please select both 'From' and 'To' dates.");
      return;
    }

    setIsDownloadingCSV(true);

    try {
      const response = await axios.get(
        `/api/download-excel?fromDate=${fromDate}&toDate=${toDate}`,
        { responseType: "blob" }
      );

      const url = URL.createObjectURL(response.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "survey-report.xlsx";
      a.click();
    } catch (error) {
      setErrorMessage("An error occurred while downloading the report.");
    } finally {
      setIsDownloadingCSV(false);
    }
  };

  return (
    <div className="admin-dashboard">

      {/* Header */}
      <header className="admin-header">
        <span className="admin-welcome-message">Welcome, {adminEmail}</span>
        <button onClick={handleLogout} className="admin-logout-link">
          <img src={logoutIcon} alt="Logout" className="logout-img" />
        </button>
      </header>

      {/* Fixed blue box */}
      <section className="admin-center-box">
        <img src={logo} alt="Logo" className="admin-dashboard-logo" />

        <div className="admin-controls">
          <label>Email</label>
          <input
            type="email"
            placeholder="Enter user email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button onClick={handleViewResults} className="admin-view-results-btn">
            {isLoadingAnalysis ? "Loading..." : "View"}
          </button>

          <label>From</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />

          <label>To</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />

          {/* Existing download button opme the bwlow comenrt after devlopment*/}
          {/* <button 
          onClick={handleDownloadByDate} className="admin-download-csv-btn">
          
            {isDownloadingCSV ? "Downloading..." : "Download Report"}
          
          </button> */}

<button
  onClick={() => setShowDownloadDevModal(true)}
  className="admin-download-csv-btn"
>
  Download Report
</button>

{showDownloadDevModal && (
  <div className="modal-overlay">
    <div className="modal-box">

      <h3>Feature Under Development</h3>

      <p style={{ marginTop: "10px" }}>
        Download Report functionality is currently under development.
        Please check back later.
      </p>

      <div className="modal-actions">
        <button
          className="admin-view-results-btn"
          onClick={() => setShowDownloadDevModal(false)}
        >
          Close
        </button>
      </div>

    </div>
  </div>
)}





          {/* NEW BUTTON → opens modal */}
          <button
            onClick={() => setShowDownloadModal(true)}
            className="admin-view-results-btn"
          >
            Participant Report
          </button>
        </div>

        {errorMessage && <p className="admin-error">{errorMessage}</p>}
      </section>

      {/* Chart section */}
      {userId && (
        <section className="admin-analysis">
          <CategoryAnalysis userId={userId} />
        </section>
      )}

      {/* ---------------------- MODAL ---------------------- */}
      {showDownloadModal && (
        <div className="modal-overlay">
          <div className="modal-box">

            <h3>Download Participant Report</h3>

            <label>Select Program</label>
            <select className="select-pax"
              value={selectedProgram}
              onChange={(e) => handleProgramSelect(e.target.value)}
            >
              <option value="">-- Select Program --</option>
              {programs.map((p) => (
                <option key={p.program_id} value={p.program_id}>
                  {p.program_name}
                </option>
              ))}
            </select>

            <label>Select Participant</label>
            <Select
  options={participants.map((u) => ({
    value: u.user_id,
    label: `${u.name} (${u.email})`
  }))}
  onChange={(selected) => setSelectedParticipant(selected?.value)}
  placeholder="Select Participant"
  isDisabled={!selectedProgram}
  styles={{
    menu: (provided) => ({
      ...provided,
      zIndex: 9999999
    })
  }}
/>

            <div className="modal-actions">
              <button className="modal-cancel" onClick={() => setShowDownloadModal(false)}>
                Cancel
              </button>

              <button
                className="admin-view-results-btn"
                disabled={!selectedParticipant}
                onClick={handleDownloadParticipantReport}
              >
                Download
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
